import req from './../../fetch';
import {
  AllAPIResponses,
  CarbonError,
  UserSubscriptionType,
} from './../../index';

import { undocumentedResponse } from './../../utils';

type Payload = {
  notificationSchemaId: number;
  schedule?: string;
  userId: number;
};
const post = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<UserSubscriptionType>> => {
  try {
    const resp = await req.post(
      '/api/usersubscriptions',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as UserSubscriptionType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
